import React, { PureComponent } from 'react';
import './index.scss';

class CouponContainer extends PureComponent {
  
  render() {
    const {
    background,
    titleBg,
    style} = this.props;
    return(
      <div className="coupon-container" style={{...style,background:background}}>
      <div className="coupon-container-title" style={{backgroundImage: `url(${titleBg})`}}/>
      {this.props.children}
      </div>
    )
  }
}
 

export default CouponContainer;